import React from "react"
import styled from "styled-components"
import PropTypes from "prop-types"
import { Breadcrumb, BreadcrumbItem, Col, Row } from "reactstrap"

const STATIC_BREADCRUMB_ITEMS = [
  {
    key: Math.round(Math.random() * 10000),
    label: "All media sources",
    value: {
      group_by: [{ label: "Media source", value: "media_source" }],
      filter_by: []
    }
  }
]

const CohortReportsBreadcrumb = ({ cohort_setup, onClick }) => {

  const [items, setItems] = React.useState([])

  React.useEffect(() => {
    const { group_by, filter_by } = cohort_setup

    if (!group_by[0]) return void 0;

    const f_mediaSource = filter_by.find(i => i.value.value === "media_source" && i.sub_value.length === 1)
    const f_campaign = filter_by.find(i => i.value.value === "campaign" && i.sub_value.length === 1)

    const hasMediaSource = !!f_mediaSource
    const hasCampaign = !!f_campaign

    const arr = [...STATIC_BREADCRUMB_ITEMS]

    if (
      (group_by.some(i => i.value === "campaign" || i.value === "ad")) &&
      (hasMediaSource)
    ) { // At Ad (2th)
      arr.push({
        key: Math.round(Math.random() * 10000),
        label: f_mediaSource.sub_value[0].label,
        value: !hasCampaign ? null : ({
          group_by: [{ label: "Campaign", value: "campaign" }],
          filter_by: [f_mediaSource]
        })
      })
    }

    if (
      (group_by.some(i => i.value === "ad")) &&
      (hasCampaign) &&
      (hasMediaSource)
    ) { // At Ad (3th)

      arr.push({
        key: Math.round(Math.random() * 10000),
        label: f_campaign.sub_value[0].label,
        value: null
      })
    }

    setItems(arr)

  }, [cohort_setup])

  const onClickItem = value => {
    if (!value) return void 0
    onClick(value)
  }

  return (
    <CohortReportsBreadcrumbStyled>
      <Row>
        <Col xs="12">
          <div className="page-title-box d-sm-flex align-items-center justify-content-between">
            <div className="page-title-left">
              <Breadcrumb listClassName="m-0">
                {items.length > 0 && items.map((i, idx) => (
                  <BreadcrumbItem key={i.key} active={idx + 1 === items.length}>
                    <span onClick={() => onClickItem(i.value)}>
                        {i.label}
                    </span>
                  </BreadcrumbItem>
                ))}
              </Breadcrumb>
            </div>
          </div>
        </Col>
      </Row>
    </CohortReportsBreadcrumbStyled>
  )
}

CohortReportsBreadcrumb.propTypes = {
  cohort_setup: PropTypes.any,
  onClick: PropTypes.func
}

const CohortReportsBreadcrumbStyled = styled.div`

  .breadcrumb-item:not(:last-child) {
    transition-duration: 0.5s;
    cursor: pointer;

    &:hover {
      color: rgb(85, 110, 230);
      transition-duration: 0.5s;
    }
  }
`

export default (CohortReportsBreadcrumb)
